import { FC } from "react"
import { useVetisContent } from "widgets/profile/lib/useVetisContent";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { VetisContentWrapper } from "./style";


export const VetisContent: FC = () => {
  const {
    defaultBusinessEntitity,
    onButtonClick,
    onLogoutButtonClick
  } = useVetisContent();

  if (!defaultBusinessEntitity) return (
    <VetisContentWrapper>
      <Button 
        label="Привязать аккаунт"
        size="l"
        onClick={onButtonClick}
        style={{width: '100%'}}
      />
    </VetisContentWrapper>
  )

  return (
    <VetisContentWrapper>
      Вы вошли как {defaultBusinessEntitity.name || defaultBusinessEntitity.fio}
      <Button 
        label="Выйти из системы ВетИС"
        size="m"
        onClick={onLogoutButtonClick}
        style={{width: '100%'}}
      />
    </VetisContentWrapper>
  )
}